<template>
  <div id="app">
    <router-view/>
      <div class="amap-wrapper">
        <el-amap class="amap-box" :vid="'amap-vue'"></el-amap>
      </div>
  </div>
</template>

<script>

export default {
  name: 'App',
    data () {
        return {

        }
    }
}
</script>

<style  scoped>
  
</style>



// WEBPACK FOOTER //
// src/App.vue